import React from 'react';
import { Dropdown, Grid, Input, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

import Button from '../../../components/Button';
import { FieldLabel } from '../../../styles';

import { billingEstateStatusOptions } from '../constants';
import { BillingEstatesFiltersState } from '../types';

type Props = {
  filters: BillingEstatesFiltersState;
  setFilters: React.Dispatch<React.SetStateAction<BillingEstatesFiltersState>>;
  onSearch: () => void;
  onClear: () => void;
};

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  @media (max-width: 991px) {
    justify-content: flex-start;
  }

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const EstatesChargesFiltersBar: React.FC<Props> = ({
  filters,
  setFilters,
  onSearch,
  onClear
}) => {
  return (
    <Segment>
      <Grid stackable>
        <Grid.Row>
          <Grid.Column computer={6} tablet={8} mobile={16}>
            <FieldLabel>Imobiliária</FieldLabel>
            <Input
              fluid
              placeholder="Buscar por nome..."
              value={filters.name}
              onChange={(_, { value }) =>
                setFilters(prev => ({ ...prev, name: String(value) }))
              }
            />
          </Grid.Column>

          <Grid.Column computer={4} tablet={8} mobile={16}>
            <FieldLabel>Status</FieldLabel>
            <div style={{ width: '100%' }}>
              <Dropdown
                style={{ width: '100%' }}
                value={filters.status || ''}
                placeholder="Todos"
                options={billingEstateStatusOptions}
                selection
                onChange={(_, { value }) =>
                  setFilters(prev => ({
                    ...prev,
                    status: (value as BillingEstatesFiltersState['status']) || ''
                  }))
                }
              />
            </div>
          </Grid.Column>

          <Grid.Column computer={6} tablet={16} mobile={16}>
            <FieldLabel>&nbsp;</FieldLabel>
            <ActionsWrapper>
              <Button type="button" text="Limpar" light onClick={onClear} />
              <Button type="button" text="Buscar" onClick={onSearch} />
            </ActionsWrapper>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default EstatesChargesFiltersBar;
